import React, { useState } from "react";

export default function Carousel() {
  const [idx, setIdx] = useState(0);

  const ts = [
    {
      quote: "The turnaround time to identify and fix problems has improved drastically since we started using DripStat",
      img: "/img/home/tile-logo-original.png",
      link: "https://blog.dripstat.com/how-tile-uses-dripstat/",
    },
    {
      quote: "Dripstat helped us make some architecture decisions on an upcoming rewrite of one of our key systems for students, faculty and staff",
      img: "/img/home/uwf-logo-original.png",
      link: "https://blog.dripstat.com/how-univ-of-west-florida-uses-dripstat/",
    },
    {
      quote: "We are getting great insight into performance characteristics and behaviours. Truly invaluable..",
      img: "/img/home/pa-logo-original.png",
    },
  ];

  const maxIdx = ts.length - 1;

  function onNext() {
    if (idx >= maxIdx) {
      setIdx(0);
    } else {
      setIdx(idx + 1);
    }
  }

  function onPrev() {
    if (idx > 0) {
      setIdx(idx - 1);
    } else {
      setIdx(maxIdx);
    }
  }

  const cur = ts[idx];

  return (
    <div className="testimonial-carousel">
      <div className="columns">
        <div className="column is-1">
          <div onClick={onPrev} className="carousel-control">
            &lt;
          </div>
        </div>
        <div className="column">
          <div className="tml">
            <div className="columns is-vcentered">
              <div className="column is-one-fifth has-text-centered">
                <img src={cur.img} alt="" />
              </div>
              <div className="column quote">{cur.quote}</div>
            </div>
            <div className="columns is-centered">
              <div className="column is-one-fifth">{cur.link && <a href={cur.link}>Learn More</a>}</div>
            </div>
          </div>
        </div>
        <div className="column is-1">
          <span onClick={onNext} className="carousel-control">
            &gt;
          </span>
        </div>
      </div>
    </div>
  );
}
